import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import images from '~/constants/images';

export default function LockView() {
  const { t } = useTranslation();
  return (
    <S.LockViewContainer>
      <S.LockBlock>
        <img src={images.lockView} alt="lockView" />
        <h4>{t('lockText')}</h4>
      </S.LockBlock>
    </S.LockViewContainer>
  );
}
